import { SET_IS_INITIAL, SET_IS_NOT_INITIAL } from "../action_types";

const isInitialReducer = function (isInitial = true, action) {
    switch (action.type) {
        case SET_IS_INITIAL:
            return true;
            
        case SET_IS_NOT_INITIAL:
            return false;
        
        default: return isInitial;
    }
};

export default isInitialReducer;